import kebabCase from 'lodash/kebabCase';
import { dataAttribute, hook } from '@g4/automation-hooks';

const hookAttribute = (...hookArgs) => {
  const hookObject = hook(...hookArgs);
  return `${dataAttribute}="${hookObject[dataAttribute]}"`;
};

const formatStringForHookValue = kebabCase;

export { formatStringForHookValue, hookAttribute };
